import { Injectable } from '@angular/core';
import { Observable, of, observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WorkflowTemplateDataService {

  constructor() { }
  public workflowtemplatedetailscache: Map<string, Observable<any>> = new Map<string, Observable<any>>();
  mapworkflowtemplate(key: string, result: any[]) {
    this.workflowtemplatedetailscache.set(key, of(result));
  }
  hasWorkflowTemplate(key: string): boolean {
    return this.workflowtemplatedetailscache.has(key)
  }
  clearWorkflowTemplate() {
    this.workflowtemplatedetailscache.clear();
  }
  deleteWorkflowTemplate(key: string) {
    if (this.workflowtemplatedetailscache.has(key)) {
        this.workflowtemplatedetailscache.delete(key);
    }
}
getWorkflowTemplate(key: string): Observable<any> {
  //return this.workflowtemplatedetailscache.get(key);
  return new Observable<any>();
}
}
